import { jsxs, jsx } from 'react/jsx-runtime';
import { themedColor, disabledInteraction, conditionalInclude, Flex, font, cssValue } from '@lemonade-hq/cdk';
import { useRef, useMemo, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { borderHighlight, animatedHighlight, rounded } from '../../styles/common.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  box-shadow: unset;\n\n  :hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  border-color: ",
        ";\n\n  :active,\n  :hover,\n  :focus-within {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  :active,\n  :focus-within {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  transform: translateY(0) scale(0.75);\n  font-size: 1.3rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n      margin-top: 22px;\n      margin-bottom: 2px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  box-sizing: border-box;\n  width: calc(100% - 2px);\n  height: calc(100% - 25px);\n  border: none;\n  color: ",
        ";\n  padding: 0 15px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  overflow: auto;\n  outline: none;\n  resize: none;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n\n  &::placeholder {\n    color: ",
        ";\n    text-transform: uppercase;\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n    width: ",
        ";\n    height: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    ",
        ";\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  border: 1px solid ",
        ";\n  ",
        ";\n  ",
        "\n\n  :hover, :focus-within {\n    border-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n    ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 4px;\n  left: 16px;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  transition: all 0.15s ease-out;\n  user-select: none;\n  transform-origin: 0 100%;\n  transform: translateY(12px);\n  cursor: text;\n  color: ",
        ";\n  text-transform: uppercase;\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
var DEFAULT_HEIGHT = 55;
var highlightErrorStyle = css(_templateObject(), borderHighlight, themedColor("primary"));
var errorStyle = css(_templateObject1(), themedColor("primary"), themedColor("primary"));
var highlightStyle = css(_templateObject2(), borderHighlight, animatedHighlight);
var disabledView = css(_templateObject3(), disabledInteraction, themedColor("cloud"), themedColor("metal"));
var floatingStyle = css(_templateObject4());
var InputElement = styled.textarea(_templateObject7(), themedColor("night"), themedColor("metal"), function(param) {
    var disabled = param.disabled;
    return css(_templateObject5(), conditionalInclude(disabled, disabledView));
}, function(param) {
    var hasValue = param.hasValue, floatingLabel = param.floatingLabel;
    return hasValue && floatingLabel && css(_templateObject6());
});
var InputContainer = styled(Flex)(_templateObject10(), themedColor("glass"), rounded, font("main", {
    fontSize: "1.4rem",
    fontWeight: 700
}), themedColor("pebble"), function(param) {
    var _param_width = param.width, width = _param_width === void 0 ? "100%" : _param_width, _param_height = param.height, height = _param_height === void 0 ? DEFAULT_HEIGHT : _param_height;
    return css(_templateObject8(), cssValue(width), cssValue(height));
}, function(param) {
    var disabled = param.disabled, highlight = param.highlight, error = param.error, highlightError = param.highlightError;
    return css(_templateObject9(), conditionalInclude(disabled, disabledView), conditionalInclude(highlight, highlightStyle), conditionalInclude(highlightError, highlightErrorStyle), conditionalInclude(error, errorStyle));
});
var InputLabel = styled.label(_templateObject12(), themedColor("metal"), function(param) {
    var hasValue = param.hasValue;
    return css(_templateObject11(), conditionalInclude(hasValue, floatingStyle));
});
var TextArea = function(_param) {
    var id = _param.id, placeholder = _param.placeholder, onChange = _param.onChange, value = _param.value, width = _param.width, height = _param.height, _param_floatingLabel = _param.floatingLabel, floatingLabel = _param_floatingLabel === void 0 ? true : _param_floatingLabel, _param_highlight = _param.highlight, highlight = _param_highlight === void 0 ? false : _param_highlight, _param_highlightError = _param.highlightError, highlightError = _param_highlightError === void 0 ? false : _param_highlightError, _param_error = _param.error, error = _param_error === void 0 ? false : _param_error, className = _param.className, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_autoExpand = _param.autoExpand, autoExpand = _param_autoExpand === void 0 ? false : _param_autoExpand, nativeInputProps = _object_without_properties(_param, [
        "id",
        "placeholder",
        "onChange",
        "value",
        "width",
        "height",
        "floatingLabel",
        "highlight",
        "highlightError",
        "error",
        "className",
        "disabled",
        "autoExpand"
    ]);
    var inputRef = useRef(null);
    var memoizedId = useMemo(function() {
        return id !== null && id !== void 0 ? id : Date.now().toString();
    }, [
        id
    ]);
    var hasValue = value != null && value.length > 0;
    var placeholderText = floatingLabel ? "" : placeholder;
    useEffect(function() {
        if (!autoExpand) return;
        /* istanbul ignore next - can't mock useRef to get null element */ if (inputRef.current == null) return;
        inputRef.current.style.height = "auto";
        inputRef.current.style.height = cssValue(inputRef.current.scrollHeight);
    }, [
        value,
        autoExpand
    ]);
    return /*#__PURE__*/ jsxs(InputContainer, {
        className: className,
        error: error,
        height: autoExpand ? "auto" : height,
        highlight: highlight,
        highlightError: highlightError,
        justifyContent: "center",
        width: width,
        children: [
            /*#__PURE__*/ jsx(InputElement, _object_spread({
                disabled: disabled,
                floatingLabel: floatingLabel,
                hasValue: hasValue,
                id: memoizedId,
                onChange: onChange,
                placeholder: placeholderText,
                ref: inputRef,
                value: value
            }, nativeInputProps, floatingLabel ? {
                "aria-labelledby": "".concat(memoizedId, "-label")
            } : {
                "aria-label": placeholder
            })),
            floatingLabel && /*#__PURE__*/ jsx(InputLabel, {
                "data-testid": "floating-label",
                hasValue: hasValue,
                htmlFor: memoizedId,
                id: "".concat(memoizedId, "-label"),
                children: placeholder
            })
        ]
    });
};

export { TextArea };
